import { Resource } from '../shared/resource';

export class StatsJobEventFilter extends Resource {
  id: string;
  name: string;
  loading: boolean;
}
